"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOfferDetail = exports.offerDetailContext = exports.OfferDetailProvider = void 0;
var _react = require("react");
var _api = require("../../api");
var _useGetOfferItemsPage = require("../../api/useGetOfferItemsPage");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- api and contents are tested separately

const offerDetailContext = exports.offerDetailContext = /*#__PURE__*/(0, _react.createContext)(_constants.offerDetailContextDefaultValue);
/**
 * Provider for the offer context with data shared between offer items (products).
 */
const OfferDetailProvider = ({
  offer,
  children
}) => {
  const {
    choiceId: offerId,
    offerType,
    validTo
  } = offer;
  const [searchTerm, setSearchTerm] = (0, _react.useState)();
  const {
    loading: loadingOfferItemsPage,
    loadMore,
    loadMoreEnabled,
    offerItems,
    totalRecords
  } = (0, _useGetOfferItemsPage.useGetOfferItemsPage)({
    offerId,
    searchTerm
  });
  const {
    loading: loadingSelectedOfferItems,
    selectedOfferItems,
    revalidate: revalidateSelectedOfferItems
  } = (0, _api.useGetSelectedOfferItems)({
    offerId
  });
  const {
    loadingQuantityChange,
    onChangeQuantity
  } = (0, _hooks.useChangeQuantity)({
    offerId,
    revalidateSelectedOfferItems
  });
  const {
    expiringPoints,
    isCampaignOffer,
    isValidityVisible,
    offerValidity,
    pointsExpirationDays
  } = (0, _hooks.useOfferConfig)({
    offerId,
    offerType,
    validTo
  });
  const {
    remainingAmount,
    remainingQuantity
  } = (0, _hooks.useGetOfferLimitsAndShoppingBagItems)({
    offer,
    selectedOfferItems
  });
  const loading = loadingOfferItemsPage || loadingQuantityChange || loadingSelectedOfferItems;
  const updatingProducts = (0, _react.useMemo)(() => loadingQuantityChange && totalRecords > 0, [loadingQuantityChange, totalRecords]);
  const value = (0, _react.useMemo)(() => ({
    expiringPoints,
    isCampaignOffer,
    isValidityVisible,
    loading,
    loadMoreEnabled,
    offer,
    offerItems,
    offerValidity,
    pointsExpirationDays,
    remainingAmount,
    remainingQuantity,
    selectedOfferItems,
    totalRecords,
    updatingProducts,
    loadMore,
    onChangeQuantity,
    searchTerm,
    setSearchTerm
  }), [expiringPoints, isCampaignOffer, isValidityVisible, loadMore, loadMoreEnabled, loading, offer, offerItems, offerValidity, onChangeQuantity, pointsExpirationDays, remainingAmount, remainingQuantity, selectedOfferItems, totalRecords, updatingProducts, searchTerm, setSearchTerm]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(offerDetailContext.Provider, {
    value: value,
    children: children
  });
};
exports.OfferDetailProvider = OfferDetailProvider;
const useOfferDetail = () => (0, _react.useContext)(offerDetailContext);
exports.useOfferDetail = useOfferDetail;